$(document).ready(function() {
  // set persona indicator

  var personaName = $.cookie('och_persona');
  if (personaName == 'no-thanks' || personaName == 'optout') {
    $('.persona-current').text("I'd prefer not to say");
  } else {
    $('.persona-current').text($.cookie('och_persona_longname'));
  }

  // set the active button if cookie is defined
  if (
    document.location.hostname === 'www.ochsner.org'
    &&
    document.location.pathname === "/"
  ) {
    if ($.cookie('och_persona') !== undefined) {
      if(document.location.search.search('home') == -1 && document.location.pathname == "/") {
        window.location.search = "?home=" + $.cookie('och_persona')
      }
      $(
          '.button-persona[data-persona-choice="' + $.cookie('och_persona') + '"]'
       ).addClass('active');
    } else if ($('#home').length) {
      $(window).on('load', function() {
        $('#personaModal').modal('show');
      });
    }
  }

  $('.button-persona').on('click', function() {
    var personaChoice = $(this).data('persona-choice');
    ochsner.setPersonaCookie('och_persona', personaChoice, 3650);
    var personaLongName = $(this).data('persona-longname');
    ochsner.setPersonaCookie('och_persona_longname', personaLongName, 3650);
    window.location.search = "?home=" + personaChoice;
  });

  $('.button-persona-delete').on('click', function() {
    ochsner.setPersonaCookie('och_persona', -1, -1);
    ochsner.setPersonaCookie('och_persona_longname', -1, -1);
  });


});

// Generate UUID -- via https://codepen.io/Jvsierra/pen/BNbEjW
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

function och_uuid() {
  if ( $.cookie('och_uuid') == undefined ) { $.cookie( 'och_uuid', guid(), { expires: 365 } ); }
	return $.cookie('och_uuid');
}

// Not actually persona stuff, but stuff ripped off from here:

var baseHostname = document.location.hostname.split('.');
baseHostname = baseHostname.slice(baseHostname.length - 2).join('.');
